/**
 * Portal Manta · LoteSummaryStrip
 * Extraído de App.jsx v29.3 (via AST)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { CONSOL_FIN } from '../../data/consol-fin.js';
import { V, fmtNum, sumBy, sigKey, fmtBRL } from '../../globals.js';

function LoteSummaryStrip({lote}){
  if(!lote) return null;
  const sig = sigKey(lote);
  const consol = CONSOL_FIN[sig] || {};
  const totSicro = Object.values(consol).reduce((s,arr)=>s+sumBy(arr,'v'),0);
  const ext = parseFloat((lote.extensao||'').replace(/[^\d,.]/g,'').replace(',','.'))||0;
  const corLote = sig==='3'?V.gn:(sig==='4'?V.bl:V.or);
  const KPI = ({l,v,s})=>(
    <div style={{display:'flex',flexDirection:'column',justifyContent:'center',padding:'0 12px',borderRight:'1px solid '+V.g2,flexShrink:0,minWidth:88}}>
      <div style={{fontSize:8.5,fontWeight:700,color:V.gr,letterSpacing:.3,textTransform:'uppercase',whiteSpace:'nowrap'}}>{l}</div>
      <div style={{fontSize:11.5,fontWeight:700,color:V.br,whiteSpace:'nowrap'}}>{v}</div>
      {s && <div style={{fontSize:8.5,color:V.gr,whiteSpace:'nowrap'}}>{s}</div>}
    </div>
  );
  return(<div style={{display:'flex',background:'#fff',borderBottom:'1px solid #DDE2EE',minHeight:42,flexShrink:0,overflowX:'auto',overflowY:'hidden',boxShadow:'0 2px 6px rgba(30,42,74,.06)'}}>
    {/* Identificador do lote */}
    <div style={{display:'flex',alignItems:'center',gap:8,padding:'0 12px',background:corLote,color:'#fff',minWidth:155,flexShrink:0}}>
      <div style={{
        width:28,height:28,borderRadius:5,background:'rgba(255,255,255,.22)',
        display:'flex',alignItems:'center',justifyContent:'center',
        fontSize:11.5,fontWeight:700
      }}>{lote.sig}</div>
      <div style={{display:'flex',flexDirection:'column'}}>
        <div style={{fontSize:8.5,opacity:.85,letterSpacing:.3,textTransform:'uppercase'}}>Lote ativo</div>
        <div style={{fontSize:11.5,fontWeight:700,whiteSpace:'nowrap'}}>{lote.nome}</div>
      </div>
    </div>
    <KPI l="Extensão" v={fmtNum(ext,1)+' km'} s={lote.fase}/>
    <KPI l="Prazo" v={lote.prazo||'—'} s={lote.orgao}/>
    <KPI l="TIR" v={lote.tir!=null?(lote.tir*100).toFixed(2)+'%':'—'} s="a.a."/>
    <KPI l="CAPEX" v={lote.capex_total_b!=null?'R$ '+fmtNum(lote.capex_total_b,2)+' bi':'—'} s="30 anos"/>
    <KPI l="OPEX" v={lote.opex_total_b!=null?'R$ '+fmtNum(lote.opex_total_b,2)+' bi':'—'} s="conservação"/>
    <KPI l="Receita" v={lote.receita_total||'—'} s="ciclo total"/>
    <KPI l="Total SICRO" v={fmtBRL(totSicro,0)} s={Object.keys(consol).length+' disciplinas'}/>
    <KPI l="R$ médio/km" v={ext?fmtBRL(totSicro/ext,0):'—'} s="todas disciplinas"/>
  </div>);
}

export { LoteSummaryStrip };
export default LoteSummaryStrip;
